import { render, staticRenderFns } from "./RetentionSwitch.vue?vue&type=template&id=bf2e12e8&"
import script from "./RetentionSwitch.vue?vue&type=script&lang=js&"
export * from "./RetentionSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports